import './style.css'
import * as dat from 'dat.gui'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'

/**
 * Base
 */
// Debug
// const gui = new dat.GUI({
//     width: 400
// })

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Loaders
 */

/**
 * Textures
 */

/**
 * Materials
 */

/**
 * Sizes
 */
 const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Model
 */

let sphereGroup = new THREE.Group()
for (let n=0; n<1000; n++) {
    let angle = n * 137.3      //137.3
    let c = 5
    let r = c * Math.sqrt(n)

    let x = r * Math.cos(angle)
    let y = r * Math.sin(angle)

    const sphereGeo = new THREE.SphereGeometry(0.07, 16, 16)
    const sphereMaterial = new THREE.MeshNormalMaterial()
    const sphereMesh = new THREE.Mesh(sphereGeo, sphereMaterial)
    sphereMesh.position.set(x/100,y/100,0.2)
    sphereGroup.add(sphereMesh)
    scene.add(sphereGroup)
}

let sphereGroup1 = new THREE.Group()
for (let n=0; n<1000; n++) {
    let angle = n * 45
    let c = 5
    let r = c * Math.sqrt(n)

    let x = r * Math.cos(angle)
    let y = r * Math.sin(angle)

    const sphereGeo = new THREE.SphereGeometry(0.07, 16, 16)
    const sphereMaterial = new THREE.MeshNormalMaterial()
    const sphereMesh = new THREE.Mesh(sphereGeo, sphereMaterial)
    sphereMesh.position.set(x/100,y/100,0)
    sphereGroup1.add(sphereMesh)
    scene.add(sphereGroup1)
}


window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0     
camera.position.z = 4    
scene.add(camera)

/**
 * Lights
 */

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.outputEncoding = THREE.sRGBEncoding
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor( 0x505050 )      //0xbbbbff

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    // Update materials
    sphereGroup.rotation.x = elapsedTime * 0.2
    sphereGroup.rotation.y = elapsedTime * 0.2    
    sphereGroup1.rotation.z = elapsedTime * 0.05

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()